import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import PortalModal from './PortalModal';

const ProfileImagePreviewModal = ({ open, imageUrl, alt = 'Profile photo', onClose }) => {
  const [zoomed, setZoomed] = useState(false);

  useEffect(() => {
    if (!open) {
      setZoomed(false);
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose?.();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);

  if (!open || !imageUrl) return null;

  return (
    <PortalModal open={open}>
      <div
        className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/85 backdrop-blur-sm p-4 sm:p-6"
        onClick={onClose}
        role="dialog"
        aria-modal="true"
        aria-label="Profile image preview"
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.96 }}
          transition={{ duration: 0.18 }}
          className="relative flex h-full w-full items-center justify-center"
          onClick={(event) => event.stopPropagation()}
        >
          <button
            type="button"
            onClick={onClose}
            className="absolute right-2 top-2 z-10 rounded-full bg-white/15 p-3 text-white backdrop-blur transition hover:bg-white/25 focus:outline-none focus:ring-2 focus:ring-white/50 sm:right-4 sm:top-4"
            aria-label="Close image preview"
          >
            <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <button
            type="button"
            className="absolute bottom-4 left-1/2 z-10 -translate-x-1/2 rounded-full bg-white/15 px-4 py-2 text-xs font-medium text-white backdrop-blur transition hover:bg-white/25 sm:hidden"
            onClick={onClose}
          >
            Tap to close
          </button>

          <img
            src={imageUrl}
            alt={alt}
            draggable={false}
            onClick={() => setZoomed((value) => !value)}
            className={`max-h-[88vh] max-w-[92vw] select-none rounded-2xl object-contain shadow-2xl transition-transform duration-200 sm:max-h-[86vh] sm:max-w-[82vw] ${
              zoomed ? 'scale-110 cursor-zoom-out' : 'scale-100 cursor-zoom-in'
            }`}
          />
        </motion.div>
      </div>
    </PortalModal>
  );
};

export default ProfileImagePreviewModal;
